import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import classes from './HotelRoomPreference.scss';

import HotelTupleWrapper from '../../../Hotel/HotelTuple/HotelTupleWrapper/HotelTupleWrapper';
import TupleBoxLeft from '../../../Hotel/HotelTuple/TupleBoxLeft/TupleBoxLeft';
import TupleBoxRight from '../../../Hotel/HotelTuple/TupleBoxRight/TupleBoxRight';
import TupleBoxCenter from '../../../Hotel/HotelTuple/TupleBoxCenter/TupleBoxCenter';
import TupleDivider from '../../../Hotel/HotelTuple/TupleDivider/TupleDivider';
import HeadingH4 from '../../../UI/Headings/HeadingH4/HeadingH4';
// import Tooltip from '../../../UI/Tooltip/Tootip';

import Button from '../../../UI/Button/Button';
import adultImage from '../../../../assets/images/adult.png';
import childImage from '../../../../assets/images/child.png';
import infoImage from '../../../../assets/images/info.svg';

class HotelRoomPreference extends Component {
    proceedToBook = (e) => {
        e.preventDefault();

        const params = new URLSearchParams(this.props.location.search);
        const queryParams = [];

        queryParams.push('roomTypeId=' + this.props.roomPreference.roomTypeId);
        queryParams.push('ratePlanId=' + this.props.roomPreference.ratePlanId);
        queryParams.push('detailId=' + this.props.detailId);
        queryParams.push('checkInDate=' + params.get("checkInDate"));
        queryParams.push('checkOutDate=' + params.get("checkOutDate"));
        queryParams.push('rooms=' + params.get("rooms"));
        queryParams.push('lob=hotel');
        const queryString = queryParams.join("&");

        this.props.history.push({
            pathname: "/reviewHotel",
            search: "?" + queryString
        });
    }

    render() {
        const inclusions = this.props.roomPreference.inclusions.map((option, index) => {
            return <li key={index} className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-noWrapWithEllipsis mb-1 u-lineHeight12`}>{option}</li>
        })

        let adults = [];
        let childs = [];

        for(let i = 0; i < this.props.roomPreference.maxAdultOccupancy; i++) {
            adults.push(<img className={classes.PaxImage} src={adultImage} alt="Adult" />);
        }

        for(let i = 0; i < this.props.roomPreference.maxChildOccupancy; i++) {
            childs.push(<img className={classes.PaxImage} src={childImage} alt="Child" />);
        }

        const params = new URLSearchParams(this.props.location.search);

        let checkInDate = params.get('checkInDate');
        let checkOutDate = params.get('checkOutDate');

        const totalNights = moment(checkOutDate, 'DD/MM/YYYY').diff(moment(checkInDate, 'DD/MM/YYYY'), 'days');

        return (
            <HotelTupleWrapper style={{marginBottom: this.props.isClubbed && !this.props.isLast ? '0' : '2rem', marginTop: this.props.isClubbed ? '0' : '2rem', boxShadow: this.props.isClubbed && this.props.optionCount !== 1 ? 'none' : '0 1px 3px 0 rgba(0, 0, 0, 0.1)'}}>
                <TupleBoxLeft isVisible={!this.props.isClubbed || (this.props.isClubbed && this.props.optionCount === 1)}>
                    {!this.props.isClubbed || (this.props.isClubbed && this.props.optionCount === 1) ? (
                        <div>
                            <img className={`u-phone-width100Percent u-phone-height140 u-width200 u-height200`} src={this.props.roomPreference.imageURL} alt="Hotel" />
                        </div>
                    ) : (
                        <div style={{backgroundColor: '#EAEAEA', height: '20rem'}}></div>
                    )}
                </TupleBoxLeft>
                <TupleBoxCenter>
                    <div className={`mb-3 u-width440 u-phone-width100Percent`}>
                        {this.props.isClubbed ? (
                            <p className={`u-fontWeightMedium u-fontSize16 u-textColorDark u-noWrapWithEllipsis`}>{`Option ${this.props.optionCount} - ${this.props.roomPreference.name}`}</p>
                        ) : <p className={`u-fontWeightMedium u-fontSize16 u-textColorDark u-noWrapWithEllipsis`}>{this.props.roomPreference.name}</p>}
                    </div>
                    <div className={`u-flex justify-content-between`}>
                        <div className={`f-fill`}>
                            <div className={`mb-2`}>
                                <HeadingH4 size={13} weight="Medium" color="Normal">Highlights</HeadingH4>
                            </div>
                            <ul className={`u-height100Percent u-overflowScrollY`}>
                                <li>{this.props.roomPreference.freeCancellation ? 'Free Cancellation' : 'Cancellation Conditional'} {this.props.roomPreference.cancellationPolicies ? <span><img src={infoImage} alt="Info" /></span> : null}</li>
        {this.props.roomPreference.freeCancellation && this.props.roomPreference.freeCancelDeadLine ? <li className="u-textColorLight u-fontSize11">(Till {this.props.roomPreference.freeCancelDeadLine})</li> : null}
                            </ul>
                        </div>
                        <TupleDivider/>
                        <div className={`f-fill`}>
                            <div className={`mb-1`}>
                                <HeadingH4 size={13} weight="Medium" color="Normal">Max Guests</HeadingH4>
                            </div>
                            <div className={`u-flex align-items-center u-textAlignCenter`} >
                                <span>{adults}</span>
                                {this.props.roomPreference.maxChildOccupancy ? (
                                    <React.Fragment>
                                        <span className={`ml-2 mr-2`}>+</span>
                                        <span className={`align-self-end`}>{childs}</span>
                                    </React.Fragment>
                                ) : null}
                            </div>
                        </div>
                        <TupleDivider/>
                        <div className={`u-width180 u-phoneHide`}>
                            <div className={`mb-1`}>
                                <HeadingH4 size={13} weight="Medium" color="Normal">Inclusions</HeadingH4>
                            </div>
                            <ul className={`u-height100Percent u-overflowScrollY`}>{inclusions}</ul>
                        </div>
                        <div className={`u-phoneShow u-flex f-column justify-content-center`}>
                            <div><span className={`u-fontWeightMedium u-textColorDark u-fontSize24`}>&#8377; {this.props.roomPreference.fareBreakup.find(rateType => rateType.label === 'Net Fare').value.toLocaleString()}</span></div>
                            <div><Button onClick={this.proceedToBook} theme="Primary" type="Hotel">Book Now</Button></div>
                        </div>
                    </div>
                </TupleBoxCenter>
                <TupleBoxRight>
                <div style={{right: '58px', top: '4px'}} className={`u-absolute`}><span className={`u-fontWeightRegular u-textColorLight u-fontSize11 u-textLineThrough`}>&#8377; {this.props.roomPreference.fareBreakup.find(rateType => rateType.key === 'total').value.toLocaleString()}</span></div>
                    <div className={`u-lineHeight1`}><span className={`u-fontWeightMedium u-textColorDark u-fontSize24 u-lineHeight1`}>&#8377;{this.props.roomPreference.fareBreakup.find(rateType => rateType.key === 'netFare').value.toLocaleString()}</span></div>
                    <div style={{marginTop: '-16px'}} className={`u-lineHeight1`}><span className={`u-fontSize13 u-fontWeightRegular u-textColorLight u-lineHeight1`}>For {totalNights} nights</span></div>
                    <div><span className={`u-fontSize13 u-fontWeightRegular u-textColorGreenDark`}>Your Income &#8377;{this.props.roomPreference.fareBreakup.find(rateType => rateType.key === 'agentProfit').value.toLocaleString()}</span></div>
                    <div><Button onClick={this.chooseRoomHandler} theme="Primary" type="Hotel">Book</Button></div>
                    <div>{this.props.roomPreference.roomsLeft ? <span className={`u-textColorTomato u-fontSize13 u-fontWeightRegular`}>{this.props.roomPreference.roomsLeft} Rooms Left</span> : null }</div>
                </TupleBoxRight>
            </HotelTupleWrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        detailRates: state.hotels.detailRates,
        detailId: state.hotels.detailId
    }
}

export default withRouter(connect(mapStateToProps)(HotelRoomPreference));


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelRoomPreferences/HotelRoomPreference/HotelRoomPreference.js